// extracted by mini-css-extract-plugin
module.exports = {"backlineMarkdown":"styles-module__backlineMarkdown___1QajR"};